var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBodyBuildingAndWeightlifting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fitness-Dumbbell-Lift--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fitness Dumbbell Lift Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h-2A1.5 1.5 0 0 0 19 1.5v3a0.5 0.5 0 0 1 -0.5 0.5 0.5 0.5 0 0 0 -0.5 0.5v3a0.5 0.5 0 0 0 0.5 0.5 0.5 0.5 0 0 1 0.5 0.5v3a1.5 1.5 0 0 0 1.5 1.5h2a1.5 1.5 0 0 0 1.5 -1.5v-11A1.5 1.5 0 0 0 22.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5a0.5 0.5 0 0 0 -0.5 -0.5h-1a0.5 0.5 0 0 1 -0.5 -0.5v-3A1.5 1.5 0 0 0 3.5 0h-2A1.5 1.5 0 0 0 0 1.5v11A1.5 1.5 0 0 0 1.5 14h2A1.5 1.5 0 0 0 5 12.5v-3a0.5 0.5 0 0 1 0.5 -0.5H6a1 1 0 0 0 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 2H8.44a2 2 0 0 0 -1.35 0.53 2.08 2.08 0 0 0 -0.47 0.64 0.24 0.24 0 0 0 0 0.22 0.24 0.24 0 0 0 0.18 0.13 2 2 0 0 1 1.69 2v3a2 2 0 0 1 -1.57 1.95 0.25 0.25 0 0 0 -0.19 0.17 0.24 0.24 0 0 0 0 0.23L8 12.41a2 2 0 0 1 0.44 1.34L8 23.48a0.57 0.57 0 0 0 0.14 0.37 0.55 0.55 0 0 0 0.36 0.15h6.93a0.51 0.51 0 0 0 0.37 -0.16 0.56 0.56 0 0 0 0.13 -0.39l-0.9 -9.38a2 2 0 0 1 0.23 -1.07l1 -2.07a2 2 0 0 0 0.24 -0.93V4a2 2 0 0 0 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBodyBuildingAndWeightlifting);
export default ForwardRef;